import Tab from "components/Tab";
import GenerationEvent from "../../../../contents/docs/llm-analytics/_snippets/generation-event.mdx";
import TraceEvent from "../../../../contents/docs/llm-analytics/_snippets/trace-event.mdx";
import SpanEvent from "../../../../contents/docs/llm-analytics/_snippets/span-event.mdx";
import EmbeddingEvent from "../../../../contents/docs/llm-analytics/_snippets/embedding-event.mdx";
import * as React from 'react';
export default {
  Tab,
  GenerationEvent,
  TraceEvent,
  SpanEvent,
  EmbeddingEvent,
  React
};